import React, {useState} from 'react';
import Cookies from 'js-cookie';
import {Dialog, Flex} from '@priority-software/priority-style-react';
import {cookieName} from './texts/utils';
import {DialogHeader} from './DialogHeader';
import {FirstSlide} from './FirstSlide';
import {SecondSlide} from './SecondSlide';
import {MessageDetails, Topic} from './types';
import styles from './UpgradeDialog.module.scss';
import UpgradeImage from '../../images/upgrade.svg';
import StayUpdatedImg from '../../images/stayUpdated.svg';
import {getIsTabulaGroup} from '../../_shared/GWTBridge/invoke/common';
import {monitorAction} from '../../services/datadog';
import {UpgradeDialogMonitoring} from '../../constants/monitoring';
import {setUserConsent} from '../../services/rest/userConsent';

type Message = {
    type: string;
    details: MessageDetails;
};

export const UpgradeDialog = () => {
    const [isOpen, setIsOpen] = useState<boolean>(true);
    const [slide, setNextSlide] = useState<number>(1);

    const onNext = () => {
        monitorAction(UpgradeDialogMonitoring.next);
        setNextSlide(2);
    };

    const onDecline = () => {
        monitorAction(UpgradeDialogMonitoring.decline);
        setIsOpen(false);
    };

    const onAccept = async (topics: Topic[]) => {
        const data = {};
        topics.forEach(topic => {
            const value = topic.selected ? 'yes' : 'no';
            data[topic.label] = value;
        });

        await setUserConsent(1, JSON.stringify(data));
        monitorAction(UpgradeDialogMonitoring.accept);
        setIsOpen(false);
    };

    const message: Message = (window as any)?.priorityMessage;
    const shouldExecute = getIsTabulaGroup() && message?.type === 'upgrade' && message.details;

    if (shouldExecute && slide === 1) {
        Cookies.set(cookieName, '1', {expires: 7});
    }

    return shouldExecute ? (
        <Dialog
            isOpen={isOpen}
            closable={false}
            maskClosable={false}
            componentClasses={styles.dialogWrapper}
            content={
                <Flex componentClasses={styles.dialogContent}>
                    <div className={styles.imageWrapper}>
                        <img
                            src={slide === 1 ? UpgradeImage : StayUpdatedImg}
                            className={styles.cardImage}
                        />
                    </div>

                    <Flex
                        direction="column"
                        alignItems="flex-start"
                        componentClasses={styles.slideContent}
                    >
                        <DialogHeader slide={slide} />
                        {slide === 1 ? (
                            <FirstSlide details={message.details} onNext={onNext} />
                        ) : (
                            <SecondSlide onAccept={onAccept} onDecline={onDecline} />
                        )}
                    </Flex>
                </Flex>
            }
        />
    ) : null;
};
